import React, {Component} from 'react';
import {Link} from "react-router-dom";

class NotFoundPage extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="inner_article">
                <h2 id="kakaoBody" className="screen_out">블로그관리 본문</h2>
                <div className="info_none">
                    <p className="txt_none">
                        <span className="wrap_ico"><span className="ico_blog ico_post"/></span>
                        요청하신 페이지를 찾을 수 없습니다.<br/>
                        <Link to={"/"} className="link_none">
                            <span >처음으로 돌아가기</span>
                        </Link>
                    </p>
                </div>

            </div>
        );
    }
}

export default NotFoundPage;
